import { useEffect, useState } from 'react';
import { getCloudItem, setCloudItem } from '../utils/cloudStorage';

export const useCloudFlag = (key: string, defaultValue = false) => {
  const [flag, setFlag] = useState(defaultValue);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCloudItem(key,String(defaultValue))
      .then(async (value) => {
        if (value === null || value === '') {
          await setCloudItem(key, String(defaultValue));
          setFlag(defaultValue);
        } else {
          setFlag(value === 'true');
        }
      })
      .finally(() => setLoading(false));
  }, [key, defaultValue]);

  const updateFlag = async (next: boolean) => {
    setFlag(next);
    try {
      await setCloudItem(key, String(next));
    } catch (e) {
      console.error('Ошибка сохранения CloudStorage', e);
    }
  };

  return [flag, updateFlag, loading] as const;
};